/**
 * Pure utility functions for formatting and checking employee access status.
 * Extracted for cross-module consistency and unit testing.
 */

export const isRecordOnly = (employee) => {
    return employee?.access_type === 'RECORD_ONLY';
};

export const isDashboardAccount = (employee) => {
    return (
        employee?.access_type === 'DASHBOARD_ACCOUNT' || !employee?.access_type
    );
};

export const formatEmployeeOptionLabel = (employee, translateFn) => {
    if (!employee) return '';
    const t = typeof translateFn === 'function' ? translateFn : (key) => key;

    const name =
        `${employee.first_name || ''} ${employee.last_name || ''}`.trim() ||
        employee.name ||
        '';

    if (employee.deactivated_at) {
        const suffix =
            t('team.table.status.deactivatedSuffix') || 'deactivated';
        return `${name} (${suffix})`;
    }
    if (employee.access_type === 'RECORD_ONLY') {
        const suffix = t('team.table.status.recordOnlySuffix') || 'No access';
        return `${name} (${suffix})`;
    }
    if (!employee.invite_accepted_at) {
        const suffix = t('team.table.status.pendingSuffix') || 'pending';
        return `${name} (${suffix})`;
    }
    return name;
};
